/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {Injector, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbActionsModule,
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule, NbIconModule, NbLayoutModule,
  NbMenuModule, NbSearchModule,
  NbSidebarModule,
  NbToastrModule, NbUserModule,
  NbWindowModule,
} from '@nebular/theme';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SharedModule} from "@modules/shared/shared.module";
import {NbSecurityModule} from "@nebular/security";
import {LoanApplicationFooterComponent} from "@layout/loan-application-footer/loan-application-footer.component";
import {LoanApplicationHeaderComponent} from "@layout/loan-application-header/loan-application-header.component";
import {LoanApplicationLayoutComponent} from "@layout/loan-application-layout/loan-application-layout.component";
import {TokenInterceptor} from "@app/@core/interceptors/token.interceptor";
import {AuthGuard} from "@app/@core/interceptors/auth.guard";
import {NbAuthModule, NbAuthService, NbTokenService, NbTokenStorage} from "@nebular/auth";
import { AdminHeaderComponent } from './layout/admin-header/admin-header.component';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import {ProfileComponent} from "@layout/profile/profile.component";
import {USStateService} from "ng2-us-states";
import { AppUserLayoutComponent } from './layout/app-user-layout/app-user-layout.component';
import {CognitoService} from "@services/cognito.service";
import { IdrawHeaderComponent } from './layout/idraw-header/idraw-header.component';
import { IdrawFooterComponent } from './layout/idraw-footer/idraw-footer.component';
import { IdrawLayoutComponentComponent } from './layout/idraw-layout-component/idraw-layout-component.component';
import { IdrawWidgetLayoutComponent } from './layout/idraw-widget-layout/idraw-widget-layout.component';

@NgModule({
  declarations: [
    AppComponent,
    LoanApplicationFooterComponent,LoanApplicationHeaderComponent,
    LoanApplicationLayoutComponent, AdminHeaderComponent,
    AdminLayoutComponent,ProfileComponent, AppUserLayoutComponent,
    IdrawHeaderComponent, IdrawFooterComponent,
    IdrawLayoutComponentComponent,
    IdrawWidgetLayoutComponent,

     ],


  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    ThemeModule.forRoot(),
    NbLayoutModule,
    NbIconModule,
    FormsModule,
    ReactiveFormsModule,
    NbActionsModule,
    NbSearchModule,
    NbUserModule,
    SharedModule,
    NbSecurityModule,
    NbAuthModule.forRoot(),

  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true,


  },AuthGuard,USStateService],
  bootstrap: [AppComponent],

})
export class AppModule {
  constructor(private injector: Injector) {
    AppInjector = this.injector;
  }
}
export let AppInjector: Injector;


